import { render, staticRenderFns } from "./Swaps.vue?vue&type=template&id=c8876140&"
import script from "./Swaps.vue?vue&type=script&lang=js&"
export * from "./Swaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports